import { css } from 'styled-components';
import tinycolor from 'tinycolor2';

export const stylesFor = {
  smallUp: (...args) =>
    css`
      @media (min-width: 640px) {
        ${css(...args)};
      }
    `,
  mediumUp: (...args) =>
    css`
      @media (min-width: 768px) {
        ${css(...args)};
      }
    `,
  largeUp: (...args) =>
    css`
      @media (min-width: 1024px) {
        ${css(...args)};
      }
    `,
  xLargeUp: (...args) =>
    css`
      @media (min-width: 1366px) {
        ${css(...args)};
      }
    `,
  underSmall: (...args) =>
    css`
      @media (max-width: 639px) {
        ${css(...args)};
      }
    `,
  underMedium: (...args) =>
    css`
      @media (max-width: 767px) {
        ${css(...args)};
      }
    `,
  underLarge: (...args) =>
    css`
      @media (max-width: 1023px) {
        ${css(...args)};
      }
    `,
  underXLarge: (...args) =>
    css`
      @media (max-width: 1365px) {
        ${css(...args)};
      }
    `,
};

// Given a pixel size, returns the rem equivalent
// for the default body size (16px). This will be
// smaller or larger as the body size is adjusted.
export const pxToRem = px => {
  const baseBodySize = 16;
  return `${px / baseBodySize}rem`;
};

export const zIndexFor = elementName => {
  // Elements, ordered from bottom to top.
  const zIndexes = ['TileGrid', 'TileSlider', 'Nav'];

  return (zIndexes.indexOf(elementName) + 1) * 100;
};

export const darken = color => {
  return tinycolor(color)
    .darken()
    .toString();
};



// WEBPACK FOOTER //
// ./src/styles/utilities.js